import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Typography, Button, Radio, Grid, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import styled from "styled-components";
import {
    setHolidayRequestStatus
} from "./actions";
import { noSig } from "vrcore-dashboard/dist/utilities";
const StatusDiv = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 20px;
`;
let ref =""
class EditHolidayRequestModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            managerApprovalStatus: "",
            reasonDesc: "",
            reasonModal: false
        };
    }

    sendBackData = e => {
        let reasonDesc = e.target.value;
        this.setState({
            reasonDesc
        }
        );
        this.props.parentCallback(this.state.reasonDesc);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.request !== this.props.request) {
            this.setState({
                managerApprovalStatus: this.props.request.manager_approval
            });
        }
    }
    render() {
        const { isOpen, closeModal, request, setStatus } = this.props;
        return (
            <Modal isOpen={isOpen}>
                <ModalHeader>Holiday Request</ModalHeader>
                <ModalBody>
                    <StatusDiv>
                        <RadioStatus
                            text="Approved"
                            color="green"
                            checked={
                                this.state.managerApprovalStatus === "approved"
                            }
                            type="approved"
                            setStatus={status => {
                                setStatus(status);
                                this.setState({
                                    managerApprovalStatus: status
                                });
                            }}
                        />
                        <RadioStatus
                            text="Pending"
                            color="orange"
                            checked={
                                this.state.managerApprovalStatus === "pending"
                            }
                            type="pending"
                            setStatus={status => {
                                setStatus(status);
                                this.setState({
                                    managerApprovalStatus: status
                                });
                            }}
                        />
                        <RadioStatus
                            text="Declined"
                            color="red"
                            checked={
                                this.state.managerApprovalStatus === "declined"
                            }
                            type="declined"
                            setStatus={status => {
                                setStatus(status);
                                this.setState({
                                    managerApprovalStatus: status,
                                    reasonModal: true
                                });

                            }}
                        />
                        <Modal isOpen={this.state.reasonModal}>
                            <ModalHeader>
                                Reason for Declining
                            </ModalHeader>
                            <ModalBody>
                                <Typography variant="body2">
                                    <b>Reason for Declining:</b>
                                </Typography>

                                <TextField
                                    id="reason"
                                    style={{ width: "100%" }}
                                    //  value={request.reason}
                                    onChange={
                                        this.sendBackData
                                    }
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ marginLeft: "400px" }}
                                    onClick={() => {
                                        this.props.setHolidayRequestStatus(

                                            request.user_uid,
                                            "declined",
                                            request.timestamp,
                                            this.state.reasonDesc
                                        );
                                        this.setState({ reasonModal: false })
                                    }}>
                                    Save
                            </Button>
                            </ModalFooter>
                        </Modal>
                    </StatusDiv>
                    {this.state.managerApprovalStatus === "approved" || this.state.managerApprovalStatus === "pending" ?
                        <Grid container spacing={32}>
                            <InfoGridItem
                                label="User Name"
                                info={request.employee_name}
                            />
                            <InfoGridItem label="Email" info={request.user_email} />
                            <InfoGridItem
                                label="Date Requested"
                                info={request.timestamp}
                            />
                            <InfoGridItem
                                label="Total Days"
                                info={request.absence_total_days}
                            />
                            <InfoGridItem
                                label="Absence From"
                                info={request.absence_date_from}
                            />
                            <InfoGridItem
                                label="Absence To"
                                info={request.absence_date_to}
                            />
                            <InfoGridItem
                                label="Type of Absence"
                                info={request.type_of_absence}
                            />
                            <InfoGridItem
                                label="Type Of Absence Other"
                                info={
                                    request.absence_date_to === ""
                                        ? "N/A"
                                        : request.type_of_absence_other
                                }
                            />
                            <InfoGridItem
                                label="Approval Date"
                                info={
                                    request.manager_approval_date === ""
                                        ? "N/A"
                                        : request.manager_approval_date
                                }
                            />
                            <InfoGridItem
                                label="Signature Timestamp"
                                info={request.signature_timestamp}
                            />
                            <Grid item xs={12} xl={12}>

                                <Typography variant="body2">
                                    <b>Signature</b>
                                </Typography>
                                <div style={{display:"none"}}>
                                    {request.signature_url.includes("https:") ? ""
                                    :
                                        ref = "data:image/png;base64,"+ request.signature_url
                                    }
                                </div>
                                {request.signature_url.includes("https:") ?
                                    <img
                                        src={
                                            request.signature_url === ""
                                                ? noSig
                                                : request.signature_url
                                        }
                                        alt="User Signature"
                                        style={{
                                            height: 170,
                                            width: 250,
                                            marginLeft: "25%"
                                        }}
                                    />
                                    :
                                    <>
                                    <img
                                        src={
                                            ref === ""
                                                ? noSig
                                                : ref
                                        }
                                        alt="User Signature"
                                        style={{
                                            height: 170,
                                            width: 250,
                                            marginLeft: "25%"
                                        }}
                                    />
                                    </>
                                }
                            </Grid>
                        </Grid> : <Grid container spacing={32}>
                            <InfoGridItem
                                label="User Name"
                                info={request.employee_name}
                            />
                            <InfoGridItem label="Email" info={request.user_email} />
                            <InfoGridItem
                                label="Date Requested"
                                info={request.timestamp}
                            />
                            <InfoGridItem
                                label="Total Days"
                                info={request.absence_total_days}
                            />
                            <InfoGridItem
                                label="Absence From"
                                info={request.absence_date_from}
                            />
                            <InfoGridItem
                                label="Absence To"
                                info={request.absence_date_to}
                            />
                            <InfoGridItem
                                label="Type of Absence"
                                info={request.type_of_absence}
                            />
                            <InfoGridItem
                                label="Type Of Absence Other"
                                info={
                                    request.absence_date_to === ""
                                        ? "N/A"
                                        : request.type_of_absence_other
                                }
                            />
                            <InfoGridItem
                                label="Approval Date"
                                info={
                                    request.manager_approval_date === ""
                                        ? "N/A"
                                        : request.manager_approval_date
                                }
                            />
                            <InfoGridItem
                                label="Signature Timestamp"
                                info={request.signature_timestamp}
                            />
                            <Grid item xs={12} xl={12}>
                                <Typography variant="body2">
                                    <b>Signature</b>
                                </Typography>
                                <img
                                    src={
                                        request.signature_url === ""
                                            ? noSig
                                            : request.signature_url
                                    }
                                    alt="User Signature"
                                    style={{
                                        height: 170,
                                        width: 250,
                                        marginLeft: "25%"
                                    }}
                                />
                            </Grid>
                        </Grid>}

                </ModalBody>
                <ModalFooter>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            closeModal();
                            // this.setState({reasonDesc:false})

                        }}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(
    store => {
    },
    { setHolidayRequestStatus }
)(EditHolidayRequestModal);

const RadioStatus = props => {
    return (
        <div style={{ display: "flex" }}>
            <Typography
                variant="body2"
                style={{ color: props.color, marginTop: 10 }}
            >
                <b>{props.text}</b>
            </Typography>
            <Radio
                color="primary"
                checked={props.checked}
                value={props.type}
                onClick={event => props.setStatus(event.target.value)}
            />
        </div>
    );
};

const InfoGridItem = props => {
    return (
        <Grid item xl={6} xs={6}>
            <div style={{ display: "flex" }}>
                <Typography
                    style={{ maxWidth: 100, marginRight: 10 }}
                    variant="body2"
                >
                    <b>{props.label}:</b>
                </Typography>
                <Typography variant="body2">{props.info}</Typography>
            </div>
        </Grid>
    );
};
